import React from 'react';
import SEO from "../../common/SEO";
import FooterThreeAlt from '../../common/footer/FooterThreeAlt';
import SectionTitle from "../sectionTitle/SectionTitle";
import ContentOne from "./ContentOne";
import HeaderTwo from '../../common/header/HeaderTwo';

const Content = () => {
    return (
        <>
            <SEO title="LearningQ Life Skills Training" />
            <main className="page-wrapper">
              
                <HeaderTwo btnStyle="btn-small" HeaderSTyle="header-transparent" />
               
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        title = "LearningQ is ready to help you build amazing content."
                                        description = ""
                                    />
                                </div>
                            </div>
                            <ContentOne />
                        </div>
                    </div>
                    {/* End Contact Area  */}
                </div>
		     <FooterThreeAlt />
             </main>
            
        </>
    )
}
export default Content;